import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Delete,
  GetAllWalletHistory,
  Status,
} from "../../../../features/admin/customer_wallet/wallet_history/slice";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const country = useSelector((state) => state.customer_wallet.wallet_history);

  const [first_name, setName] = useState("");
  const [email, setemail] = useState("");
  const [contact_no, setcontact_no] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  useEffect(() => {
    fetch();
  }, [first_name, email, contact_no, from, to]);

  const fetch = async (page = country?.current_page) => {
    await dispatch(
      GetAllWalletHistory({
        first_name: first_name,
        email,
        contact_no,
        from,
        to,
        page: page,
        per_page: country?.per_page,
      })
    );
  };

  // const deleteData = async (id) => {
  //   try {
  //     await dispatch(Delete(id));
  //     await fetch();
  //     return true;
  //   } catch (error) {
  //     console.error(error);
  //     return false;
  //   }
  // };

  // const toggleStatus = async (id) => {
  //   try {
  //     await dispatch(Status(id));
  //     await fetch();
  //     return true;
  //   } catch (error) {
  //     console.error(error);
  //     return false;
  //   }
  // };

  return {
    country,
    first_name,
    setName,
    email,
    setemail,
    contact_no,
    setcontact_no,
    from,
    setFrom,
    to,
    setTo,
    fetch,
    // deleteData,
    // toggleStatus,
  };
};
